import { publicBrandSchema, type PublicBrand } from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE_URL, ApiRequestError, apiFetch } from '@/lib/api';

export const publicBrandQueryKey = ['public', 'brand'] as const;

export function usePublicBrand() {
  return useQuery({
    queryKey: publicBrandQueryKey,
    queryFn: () => apiFetch('/public/brand', publicBrandSchema),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

export function publicBrandLogoSrc(logoUrl: string | null | undefined): string | null {
  if (!logoUrl?.trim()) {
    return null;
  }
  if (logoUrl.startsWith('http://') || logoUrl.startsWith('https://')) {
    return logoUrl;
  }
  if (API_BASE_URL.startsWith('http')) {
    try {
      const base = new URL(API_BASE_URL);
      if (logoUrl.startsWith('/api')) {
        return `${base.origin}${logoUrl}`;
      }
      return new URL(logoUrl, base).href;
    } catch {
      return logoUrl;
    }
  }
  return logoUrl;
}

export function brandDisplayName(brand: PublicBrand | undefined, fallback = ''): string {
  return brand?.name?.trim() ?? fallback;
}

export function isTenantSuspendedBrandError(error: unknown): error is ApiRequestError {
  return error instanceof ApiRequestError && error.error.code === 'TENANT_SUSPENDED';
}
